@import '^scss-config';

.gray20 {
  fill: var(--theme-color-grey-20);
}

.gray40 {
  fill: var(--theme-color-grey-40);
}

.white {
  fill: var(--theme-color-white);
}
